import SponsorshipsPageScreen from './SponsorshipsPageScreen';
import SponsorshipsPageScreenContainer from './SponsorshipsPageScreenContainer';

export { SponsorshipsPageScreen as default, SponsorshipsPageScreenContainer };
